import { Link } from 'react-router-dom'
import ScrollReveal from './ScrollReveal'
import './CTASection.css'

interface CTASectionProps {
  title?: string
  description?: string
  buttonText?: string
  buttonLink?: string
}

function CTASection({
  title = "Ready to discuss your needs?",
  description = "Every engagement starts with a conversation. No charge, no commitment—just an exploration of whether we can help.",
  buttonText = "Get in touch",
  buttonLink = "/contact"
}: CTASectionProps) {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <ScrollReveal>
          <h2>{title}</h2>
          <p>{description}</p>
          <Link to={buttonLink} className="cta-button-link">{buttonText}</Link>
        </ScrollReveal>
      </div>
    </section>
  )
}

export default CTASection
